const TRANSPORT_METHODS = ['error', 'info', 'warn'];

let LOGS_URL = '';
try {
  LOGS_URL = (window.process && process.env && process.env.REACT_APP_LOGS_URL) || '/logs';
} catch (e) {
  LOGS_URL = '/logs';
}

const send = async messages => {
  try {
    await fetch(LOGS_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(messages),
    });
  } catch (e) {
    /* noop */
  }
};

const transportFactory = method => {
  /* eslint-disable-next-line */
  let messages = [];
  let timeout;

  return message => {
    if (method === 'error' && message.message) {
      messages.push({ method, message: message.message, stack: message.stack });
    } else {
      messages.push({ method, message });
    }
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      send([...messages]);
      messages = [];
    }, 1000);
  };
};

const patch = methods =>
  Object.entries(methods).reduce((memo, [name, fn]) => {
    const transport = TRANSPORT_METHODS.includes(name) ? transportFactory(name) : () => {};
    return {
      ...memo,
      [name]: (...args) => {
        transport(...args);
        fn(...args);
      },
    };
  }, {});

export default patch;
